import React from 'react';

import { DollarIcon, NoteIcon } from 'app/shared/componentsRestyled/coreDesignSystem/icons';
import _ from 'lodash';

import { StatusColor, StatusEnum } from 'constants/status';
import { formatNumberToCurrencyString } from 'utils/number';

import QualificationDetails from './QualificationDetails';
import { NOT_APPLICABLE } from './QualificationDetails/QualificationDetails.constants';

const SUMMARY_CARDS_NAMES = {
  REQUIRED_RESERVES_AMOUNT: 'Required Reserves Amount',
  MONTHS_RESERVES: 'Months Reserves',
};

export const getSummaryInfoConfig = ({
  monthsInReserve,
  requiredReservesAmount,
  cashFromToBorrower,
  householdTotalAssets,
}) => {
  const iconColor = _.gte(householdTotalAssets, _.sum([requiredReservesAmount, cashFromToBorrower]))
    ? StatusColor[StatusEnum.SUCCESS]
    : StatusColor[StatusEnum.ERROR];

  return [
    {
      name: SUMMARY_CARDS_NAMES.REQUIRED_RESERVES_AMOUNT,
      value: _.isNumber(requiredReservesAmount)
        ? formatNumberToCurrencyString(requiredReservesAmount)
        : NOT_APPLICABLE,
      icon: <DollarIcon />,
      iconColor,
      withInfoIcon: true,
      disableInteractive: false,
      hoverContent: <QualificationDetails />,
    },
    {
      name: SUMMARY_CARDS_NAMES.MONTHS_RESERVES,
      value: _.isNumber(monthsInReserve) ? monthsInReserve : NOT_APPLICABLE,
      icon: <NoteIcon />,
      iconColor,
    },
  ];
};
